<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <SaleIvoicesReportsFiltersForm
      ref="sale-ivoices-reports-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import SaleIvoicesReportsFiltersForm from "@/components/sale-invoices-reports/form/SaleInvoicesReportsFiltersForm.vue"

export default {
  name: 'SaleInvoicesReportsListFilters',
  components: {
    BaseFiltersSideBar,
    SaleIvoicesReportsFiltersForm
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['sale-ivoices-reports-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>